"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addressEpics = exports.loadAddressEpic = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _operators = require("rxjs/operators");

var _utils = require("@alycecom/utils");

var _services = require("@alycecom/services");

var _uuid = require("uuid");

var _address = require("./address.actions");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var loadAddressEpic = function loadAddressEpic(action$, state$, _ref) {
  var apiService = _ref.apiService;
  return action$.pipe((0, _utils.ofType)(_address.loadAddressRequest), (0, _operators.switchMap)(function (_ref2) {
    var _ref2$payload = _ref2.payload,
        giftId = _ref2$payload.giftId,
        address = _ref2$payload.address;
    return apiService.get("/enterprise/gifts/".concat(giftId, "/autocomplete-address?address=").concat(address), null, true).pipe((0, _operators.map)(function (_ref3) {
      var data = _ref3.data;
      return (0, _address.loadAddressSuccess)(data.map(function (addressItem) {
        return _objectSpread(_objectSpread({}, addressItem), {}, {
          id: (0, _uuid.v4)()
        });
      }));
    }), (0, _operators.catchError)((0, _services.handleError)(_services.handlers.handleAnyError(_address.loadAddressFail))));
  }));
};

exports.loadAddressEpic = loadAddressEpic;
var addressEpics = [loadAddressEpic];
exports.addressEpics = addressEpics;